var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22 21a1 1 0 0 1 1-1h34a1 1 0 1 1 0 2H23a1 1 0 0 1-1-1M21 27a1 1 0 0 1 1-1h36a1 1 0 1 1 0 2H22a1 1 0 0 1-1-1M23 33a1 1 0 0 1 1-1h32a1 1 0 1 1 0 2H24a1 1 0 0 1-1-1M24 39a1 1 0 0 1 1-1h30a1 1 0 1 1 0 2H25a1 1 0 0 1-1-1M23 45a1 1 0 0 1 1-1h32a1 1 0 1 1 0 2H24a1 1 0 0 1-1-1M25 51a1 1 0 0 1 1-1h28a1 1 0 1 1 0 2H26a1 1 0 0 1-1-1M28 57a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H29a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgText;